'use client';

import { use } from 'react';
import { ArticleSectionRelated } from '@/app_components/ArticleSections/ArticleSectionRelated';
import type { Classification } from '@/app_lib/types/Article';
import type { ArticlePreview } from '@/app_lib/types/ArticlePreview';
import { getLatestHeading } from '@/app_lib/utils/sharedUtils';

interface LatestArticlesProps {
  articlesPromise: Promise<ArticlePreview[]>;
  section: Classification['primarySection'];
}

export const LatestArticles = ({ articlesPromise, section }: LatestArticlesProps) => {
  const articles = use(articlesPromise);

  const heading = getLatestHeading(section);

  return (
    articles?.length && (
      <ArticleSectionRelated
        articles={articles}
        heading={heading}
      />
    )
  );
};
